import { ChainID } from '@ankr.com/chains-list';
import { ETelemetryTopOf, IUsageTop } from 'multirpc-sdk';

// [preferred chain, to remove chain if preferred exists]
const PRIORITY_CHAINS = [
  [ChainID.KAIA, 'klaytn' as ChainID],
  ['aapi_v2' as ChainID, ChainID.MULTICHAIN],
];

export function filterByPriorityPairs(stats: IUsageTop[]): IUsageTop[] {
  return stats.map(topOfStat => {
    if (topOfStat.top_of === ETelemetryTopOf.BLOCKCHAIN) {
      const names = new Set(
        topOfStat.elements?.map(stat => stat.name.toLowerCase()),
      );

      const toRemove = new Set<string>();

      for (const [preferred, toRemoveIfPreferred] of PRIORITY_CHAINS) {
        if (names.has(preferred.toLowerCase())) {
          toRemove.add(toRemoveIfPreferred.toLowerCase());
        }
      }

      return {
        top_of: topOfStat.top_of,
        elements: topOfStat.elements?.filter(
          stat => !toRemove.has(stat.name.toLowerCase()),
        ),
      } as IUsageTop;
    }

    return topOfStat;
  });
}
